export function createSocioNegocio() {
  return {
    Clave: '',
    EmpresaId: 0,
    ClaveErp: '',
    TipoSocio: '',
    NombreComercial: '',
    RazonSocial: '',
    RFC: '',
    Curp: '',
    Calle: '',
    NumExt: '',
    NumInt: '',
    Colonia: '',
    Localidad: '',
    Municipio: '',
    Estado: '',
    Pais: '',
    CP: '',
    Telefono1: '',
    Telefono2: '',
    Email: '',
    ContactoNombre1: '',
    ContactoPuesto1: '',
    ContactoTelefono1: '',
    ContactoEmail1: '',
    MonedaDefault: '',
    MetodoPagoDefault: '',
    FormaPagoDefault: '',
    UsoCFDIDefault: '',
    RegimenFiscal: '',
    DiasCredito: 0,
    LimiteCredito: 0,
    SaldoActual: 0,
    EsActivo: true,
    Notas: ''
  };
}
